<template>
	<div class="pages-result__card">
		<a class="pages-result__link" :href="url">
			<component v-bind:is="contentType"></component>
			<div class="pages-result__content-col">
				<div class="pages-result__mini-kicker">{{ kicker }}</div>
				<div v-html="title"></div>
			</div>
		</a>
	</div>
</template>

<script lang="ts">
import Page from "Vue/components/searchContentTypes/Page.vue";
import News from "Vue/components/searchContentTypes/News.vue";
import Literature from "Vue/components/searchContentTypes/Literature.vue";

export default {
	name: "PagesSearchCard",
	components: {
		'page': Page,
		'newsarticle': News,
		'literature': Literature,
	},
	props: {
		url: {
			type: String,
			default: ""
		},
		contentType: {
			type: String,
			default: ""
		},
		title: {
			type: String,
			default: ""
		},
		kicker: {
			type: String,
			default: ""
		}
	}
};
</script>
